(() => {
  const dialog=document.querySelector('#GlowupCartDrawer');
  if(!dialog)return;
  let opener;
  let sequence=0;
  let cartMutation=false;
  const setCartBusy=busy=>{
    cartMutation=busy;
    document.querySelectorAll('.gh-cart').forEach(cart=>{
      cart.setAttribute('aria-busy',String(busy));
      cart.querySelectorAll('.gh-checkout,[data-offer-variant]').forEach(control=>control.disabled=busy);
      cart.querySelectorAll('[data-upsell-url],[data-cart-remove]').forEach(link=>link.setAttribute('aria-disabled',String(busy)));
    });
  };
  const profileFor=url=>{try{return JSON.parse(sessionStorage.getItem('glowup-cart-profiles')||'{}')[url];}catch{return null;}};
  const showCartUsers=root=>root.querySelectorAll('.gh-cart-item[data-delivery-link]').forEach(item=>{
    const profile=profileFor(item.dataset.deliveryLink),name=item.querySelector('[data-cart-username]');
    if(profile?.username&&name){name.textContent='@'+profile.username;name.parentElement.hidden=false;}
  });
  showCartUsers(document);
  const refresh=async()=>{
    const current=++sequence;
    const response=await fetch(dialog.dataset.sectionUrl,{headers:{Accept:'text/html'},signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw new Error('cart');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const cart=doc.querySelector('.gh-cart');
    if(!cart)throw new Error('cart');
    if(current!==sequence)return;
    dialog.querySelector('[data-cart-body]').replaceChildren(cart);showCartUsers(cart);
    if(cartMutation)setCartBusy(true);
    document.querySelectorAll('[data-gh-count]').forEach(node=>node.textContent=cart.dataset.cartCount);
  };
  const open=async()=>{
    opener=document.activeElement;
    try{await refresh();if(!dialog.open)dialog.showModal();}catch{location.assign(dialog.dataset.sectionUrl.split('?')[0]);}
  };
  document.addEventListener('click',event=>{const link=event.target.closest('[data-open-cart]');if(link){event.preventDefault();open();}});
  document.addEventListener('glowup:cart-added',open);
  document.addEventListener('change',event=>{
    const select=event.target.closest('[data-offer-variant]');if(!select)return;
    const row=select.closest('.gh-upsell'),option=select.selectedOptions[0];
    row.querySelector('[data-offer-price]').textContent=option.dataset.price;
    const link=row.querySelector('[data-upsell-url]'),url=new URL(link.href);url.searchParams.set('variant',select.value);link.href=url.href;
  });
  document.addEventListener('click',async event=>{
    const link=event.target.closest('[data-cart-remove]');if(!link)return;
    event.preventDefault();if(cartMutation||link.getAttribute('aria-busy')==='true')return;link.setAttribute('aria-busy','true');
    const form=link.closest('form'),input=link.closest('.gh-cart-item').querySelector('[name="updates[]"]');
    input.value='0';form.requestSubmit();
  });

  dialog.querySelector('.gh-cart-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left)dialog.close();}});
  dialog.addEventListener('close',()=>{if(opener?.isConnected)opener.focus();});
  document.addEventListener('click',async event=>{
    const link=event.target.closest('[data-upsell-url]');if(!link)return;
    event.preventDefault();if(cartMutation||link.getAttribute('aria-busy')==='true')return;link.setAttribute('aria-busy','true');
    setCartBusy(true);
    const row=link.closest('.gh-upsell'),cart=row.closest('.gh-cart'),select=row.querySelector('[data-offer-variant]');
    const oldLabel=link.textContent;
    const error=row.querySelector('[data-offer-error]');error.hidden=true;
    select.disabled=true;
    const checkout=cart.querySelector('.gh-checkout');if(checkout)checkout.disabled=true;
    let added=false;
    try{
      const source=JSON.parse(row.dataset.sourceProperties||'{}');
      const links=Object.entries(source).filter(([key,value])=>/^(?:Link(?: \d+(?: .*)?)?|_Delivery target)$/.test(key)&&value).map(([,value])=>value);
      if(!links.length&&row.dataset.sourceLink)links.push(row.dataset.sourceLink);
      const inherited=profileFor(links[0]);
      const targets=[...new Set(inherited?.profileUrl?[inherited.profileUrl]:links)];
      if(!targets.length)throw new Error(cart.dataset.addError);
      const properties=Object.fromEntries(targets.map((url,i)=>[targets.length===1?'Link':'Link '+(i+1),url]));
      const response=await fetch(cart.dataset.addUrl+'.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1,properties}]}),signal:AbortSignal.timeout(15000)});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||cart.dataset.addError);
      added=true;
      if(inherited){try{const saved=JSON.parse(sessionStorage.getItem('glowup-cart-profiles')||'{}');for(const target of targets)saved[target]=inherited;sessionStorage.setItem('glowup-cart-profiles',JSON.stringify(saved));}catch{}}
      if(dialog.contains(row))await refresh();else location.assign(cart.querySelector('form').action);
    }catch(cause){
      if(added){location.assign(cart.querySelector('form').action);return;}
      error.textContent=cause.message||cart.dataset.addError;error.hidden=false;
    }finally{
      select.disabled=false;link.removeAttribute('aria-busy');link.textContent=oldLabel;if(checkout)checkout.disabled=false;
      setCartBusy(false);
    }
  });
  document.addEventListener('submit',async event=>{
    if(!event.target.matches('.gh-cart-form')||event.submitter?.name==='checkout')return;
    event.preventDefault();
    if(cartMutation)return;
    setCartBusy(true);
    const form=event.target,cart=form.closest('.gh-cart');cart.setAttribute('aria-busy','true');
    try{const response=await fetch(form.action.replace(/\/cart$/, '/cart/update.js'),{method:'POST',body:new FormData(form),headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error('cart');if(dialog.contains(form)){await refresh();}else{location.assign(form.action);}}catch{location.assign(form.action);}finally{setCartBusy(false);}
  });
})();
